/**
 * Chat utility functions
 */

/**
 * Merges a token with previous content without duplicate overlap
 * Checks for overlapping sequences to avoid duplication in streaming responses
 * 
 * @param {string} prev - Previous accumulated content
 * @param {string} token - New token to merge
 * @returns {string} - Token content to append (may be empty if duplicate detected)
 */
export const mergeToken = (prev, token) => {
  if (!prev) return token || '';
  if (!token) return '';
  
  // Check for exact duplicates first (most common case)
  if (prev.endsWith(token)) {
    return '';
  }
  
  // Check for overlaps of varying lengths (be more conservative)
  const maxOverlap = Math.min(prev.length, token.length, 50); // Limit overlap check
  for (let i = maxOverlap; i >= 3; i--) { // Only check overlaps of 3+ characters
    if (prev.slice(-i) === token.slice(0, i)) {
      return token.slice(i);
    }
  }
  
  // No overlap found, return full token
  return token;
};

